__webpack_require__.p = "/learning_cards/";